import { useEffect } from 'react';
import cx from 'classnames';
import { snakeCase } from 'lodash';

import type { AnalyticsEvent } from 'Services/analytics/analytics.types';
import {
	useGetActiveSection,
	useSetActiveSection,
} from 'Stores/VehicleDetailsPositionStore/VehicleDetailsPositionStore';
import type { PageSection } from 'Types/pageSection';

import { LinkItem } from './LinkItem';
import { useOnNavigateToSectionClick } from './QuickLinks.hooks';

import styles from './QuickLinks.module.scss';

export interface QuickLinksProps {
	analytics: AnalyticsEvent;
	sections: PageSection[];
}

export const QuickLinks: React.FC<QuickLinksProps> = ({ analytics, sections }) => {
	const onNavigateToSectionClick = useOnNavigateToSectionClick({ analytics, source: 'quicklinks' });
	const activeSection = useGetActiveSection();
	const setActiveSection = useSetActiveSection();

	useEffect(() => {
		setActiveSection(sections[0].id);
	}, [sections, setActiveSection]);

	const onClick = (id: string) => {
		const label = `from: ${snakeCase(activeSection?.id)}, to: ${snakeCase(id)}`;
		onNavigateToSectionClick(id, label);
	};

	return (
		<aside className={styles.wrapper}>
			<h1 className={styles.caption}>Quick links</h1>
			<ul className={styles.linkList}>
				{sections.map(({ id, label }) => {
					const isActive = activeSection?.id === id;
					return (
						<li key={id} className={cx({ [styles.active]: isActive })}>
							<LinkItem key={id} className={styles.link} label={label} onClick={() => onClick(id)} />
						</li>
					);
				})}
			</ul>
		</aside>
	);
};
